import React, { useEffect } from "react";
import "./SunilAnandPage.css";

const SUNIL_PAGE_TITLE =
  "About Sunil Anand | Code Uniquely — Full-Stack Architect & AI Expert";
const SUNIL_PAGE_DESCRIPTION =
  "About Sunil Anand: 22+ years as a full-stack architect in React, TypeScript, Node.js, AI-powered applications, and WCAG accessibility. Code Uniquely (codeuniquely.com).";

const SunilAnandPage = () => {
  useEffect(() => {
    const meta = document.querySelector('meta[name="description"]');
    const prevDesc = meta?.getAttribute("content");
    document.title = SUNIL_PAGE_TITLE;
    if (meta) {
      meta.setAttribute("content", SUNIL_PAGE_DESCRIPTION);
    }
    return () => {
      document.title = "Sunil Anand | Full-Stack Architect, AI & Accessibility Expert";
      if (meta && prevDesc != null) {
        meta.setAttribute("content", prevDesc);
      }
    };
  }, []);

  return (
    <div className="sa-page">
      <header className="sa-header">
        <h1>Sunil Anand &ndash; Full-Stack Architect &amp; AI Solutions Expert</h1>
        <p className="sa-tagline">
          22+ years building scalable web platforms, AI-powered applications, and accessible digital experiences.
        </p>
      </header>

      <section className="sa-section">
        <h2>Who is Sunil Anand?</h2>
        <p>
          Sunil Anand is a hands-on technical leader and full-stack architect based in Pune, India.
          With over two decades of experience, Sunil specializes in React, TypeScript, Node.js, and
          modern engineering practices. He has deep expertise in architecting WCAG 2.2 AA-compliant
          eLearning platforms used by global audiences.
        </p>
        <p>
          Sunil Anand is now focused on designing AI-powered applications by integrating agentic
          workflows, LLM orchestration (LangChain, LLaMA), and intelligent automation into web
          systems &mdash; enabling adaptive behavior, decision-making flows, and context-aware user
          experiences.
        </p>
      </section>

      <section className="sa-section">
        <h2>Core Expertise</h2>
        <ul>
          <li>AI-Powered Applications &amp; Agentic Workflows</li>
          <li>LLM Orchestration &amp; Retrieval-Augmented Generation (RAG)</li>
          <li>Full-Stack Engineering: React, TypeScript, Node.js</li>
          <li>System Architecture &amp; Scalability</li>
          <li>Interactive Learning Systems &amp; SCORM Compliance</li>
          <li>WCAG 2.2 AA Accessibility-First Engineering</li>
          <li>DevOps, CI/CD Automation &amp; TDD</li>
          <li>Data-Driven Applications &amp; Real-time Systems</li>
        </ul>
      </section>

      <section className="sa-section">
        <h2>Featured Projects by Sunil Anand</h2>
        <ul>
          <li><strong>Logra &ndash; Fitness Tracker:</strong> Workout logging platform with streak tracking and progress visualization.</li>
          <li><strong>Interactive Keyboard:</strong> React + TypeScript piano/organ widget with real-time audio playback.</li>
          <li><strong>Base 10 Blocks:</strong> Virtual manipulative for learning place value and arithmetic operations.</li>
          <li><strong>Dynamic Quiz Engine:</strong> SCORM-compliant quiz platform with multilingual, RTL, and accessibility support.</li>
          <li><strong>AR/3D Car Experience:</strong> Browser-based augmented reality and 3D visualization built with Three.js.</li>
        </ul>
      </section>

      <section className="sa-section">
        <h2>Mission</h2>
        <p>
          To architect accessible, intelligent, and AI-driven digital experiences while enabling teams
          and organizations to evolve with the next generation of technology.
        </p>
      </section>

      <section className="sa-section">
        <h2>Connect with Sunil Anand</h2>
        <ul className="sa-links">
          <li><a href="https://www.linkedin.com/in/sunil-anand-ba19544/" target="_blank" rel="noopener noreferrer">LinkedIn</a></li>
          <li><a href="https://github.com/sunilanand" target="_blank" rel="noopener noreferrer">GitHub</a></li>
          <li><a href="https://twitter.com/anand_sunil" target="_blank" rel="noopener noreferrer">Twitter</a></li>
          <li><a href="mailto:anand.sonu@gmail.com">Email: anand.sonu@gmail.com</a></li>
        </ul>
      </section>

      <footer className="sa-footer">
        <a href="/">← Back to codeuniquely.com</a>
      </footer>
    </div>
  );
};

export default SunilAnandPage;
